import { createRoutine } from 'redux-saga-routines';

import { GET_VENUES, GET_VENUES_COUNTRIES, GET_VENUES_PRODUCTIONS, GET_VENUES_WITH_PRODUCTIONS } from './constants';

export const getVenuesAction = createRoutine(GET_VENUES);
export const getVenuesCountriesAction = createRoutine(GET_VENUES_COUNTRIES);
export const getVenuesProductionsAction = createRoutine(GET_VENUES_PRODUCTIONS);
export const getVenuesWithProductionsAction = createRoutine(GET_VENUES_WITH_PRODUCTIONS);
